import TimedEntry from "./TimedEntry";

const Experience = () => (
    <>
        <h2>Experience</h2>
        <TimedEntry title='CBH Group' period='2020 - Present'>
            Starting as an intern, and later becoming a full developer, I spent the first 2 years working on Dynamics 365 and Power Apps platforms,
            with a later focus on full stack development with React and Azure, working on CBH's Corporate Website and Customer Portals. <br />
            <br />
            Delivered a multitude of projects of varying complexity, working personally with stakeholders.
        </TimedEntry>
    </>
);

export default Experience;